<template>
<div class="container">

	<page-loading v-if="!data_loaded" />

	<div v-else class="row">
		<div class="col-12">
			<div class="alert alert-danger">
				<strong>Use these options very carefully!</strong> This section is available primarily to perform testing and bug checking. Permanent changes to roles and permissions should always be be done via migrations.
			</div>

	    	<div class="d-flex align-items-center">
		    	<h1 class="flex-grow-1" data-test="pageTitle">User Roles</h1>
		        <span
		        	v-tooltip.bottom="'Add Role'"
		        	@click="showAddRoleForm()"
		        	class="btn btn-sm btn-ghost-primary text-gray-500 leading-none">
		            <i class="far fa-plus-circle text-xl"></i>
		        </span>
		    </div>
		</div>	

	    <div class="col-12">
	    	<div v-if="show_form" class="card">
	    		<div class="row card-body">
	    			<div class="col form-group">
	    				<label class="mb-0">Role Name</label>
		    			<input class="form-control" v-model="form.name" required>
		    		</div>
		    		<div class="col form-group">
		    			<label class="mb-0">Access Level</label>
		    			<input class="form-control" v-model="form.access_level" type="number" required>
		    		</div>
		    		<div class="col">
		    			<label class="mb-0">Permissions</label>
				        <div v-for="(grouped_permissions, key) in permissions" class="mb-2">
				            <div class="text-blue-700 font-weight-bold">{{ key }}</div>            
				            <div class="form-check" v-for="permission in grouped_permissions">
				                <input type="checkbox" class="form-check-input" :value="permission.id" v-model="form.permissions">
				                <label class="form-check-label">{{ permission.name }}</label>
				            </div>
				        </div>
				    </div>
				    <div class="col">
            			<span class="btn btn-outline-secondary" @click="stopEditing()">Cancel</span>
            			<span class="btn btn-outline-primary" @click="saveRole()">Save</span>
				    </div>
		        </div>   		
	    	</div>

    		<div class="card">
		        <table class="table table-hover">
		            <thead>
		                <tr>
		                	<th>Role</th>
		                	<th>Access Level</th>
		                    <th>Permissions</th>
		                    <th>Operations</th>
		                </tr>
		            </thead>
		            <tbody>
		            	<role-item
		            		v-for="(role, key) in roles"
		            		:role="role"
		            		:permissions="permissions"
		            		:key="key"
		            		@delete_role="deleteRole($event)"
		            		@role_saved="refetchRoles()"
		            	/>
		            </tbody>
		        </table>
			</div>
		</div>
	</div>
</div>
</template>

<script>

	import { mapState } from 'vuex';
    import BreadcrumbsManager from '../../helpers/BreadcrumbManager';
	import RoleItem from '../../components/RoleItem.vue';

	export default {
		mixins: [BreadcrumbsManager],

		components: {
			RoleItem,
		},

        data() {
            return {
                roles: null,
                permissions: null,
                data_loaded: false,
                show_form: false,
                form: {},
            }
        },

        created() {
        	this.fetchRoles();
        	this.fetchPermissions();
        },

        activated() {
            this.setBreadcrumbs([
                { text: 'Home', to: { name: 'home' } },
                { text: 'Users', to: { name: 'users.index'} },
                { text: 'Roles', to: { name: 'roles.index'} },
            ]);  
        },

        methods: {
        	deleteRole($event) {
                Swal.fire({
                      title: 'Are you sure?',
                      text: 'You will not be able to recover this role.',
                      icon: 'warning',
                      showCancelButton: true,
                      confirmButtonText: 'Delete role',
                      cancelButtonText: 'Keep role',
                      animation: false,
                    }).then((result) => {
                    	if (result.value) {
                        	axios.delete('/api/roles/' + $event, $event).then(() => {
                            	this.roles.splice(this.roles.findIndex((role) => {
				                    return role.id === $event;
				                }), 1);
                            })
                        }
                    }
                );        		
        	},

        	fetchRoles() {
        		axios.get('/api/roles').then(({data}) => {
                    this.roles = data;
                    this.data_loaded = true;
	        	});
        	},

        	fetchPermissions() {
        		axios.get('/api/permissions').then(({data}) => {
	                this.permissions = data;
	        	});
        	},

        	newForm() {
                this.form = {
                    name: null,
                    access_level: null,
                    permissions: [],
                }
        	},

        	refetchRoles() {
        		this.data_loaded = false;
        		this.fetchRoles();
        	},

        	saveRole() {
        		axios.post('/api/roles', this.form).then(({data}) => {
        			this.roles.push(data);
        			this.newForm();
        			this.show_form = false;
        		});
        	},

        	showAddRoleForm() {
        		this.newForm();
                this.show_form = true;
        	},

        	stopEditing() {
        		this.show_form = false;
        	}
        },

        computed: {
			...mapState(['perms'])
		}
    }
</script>